import { MobileStepper, Step, StepLabel, Stepper } from '@mui/material';

/**
 * A stepper component that displays a horizontal or vertical list of steps.
 * The current step is highlighted and the user can navigate through the steps
 * by clicking on the step labels or using the mobile stepper dots.
 *
 * @property {Array}    children - Array of React components representing each step in the stepper
 * @property {Function} onSubmit - Function to call when the user clicks the submit button
 * @property {Number}   stepNumber - The index of the currently active step
 */
export default function WebStepper({ children, stepNumber }) {
  return (
    <>
      <div className="mx-auto hidden md:block">
        <Stepper activeStep={stepNumber}>
          {children.map(({ props }, idx) => (
            <Step key={idx}>
              <StepLabel>{props.label ? props.label : `Step ${idx + 1}`}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className="md:hidden">
        <MobileStepper
          activeStep={stepNumber}
          steps={children.length}
          sx={{ justifyContent: 'center' }}
          position="static"
          variant="dots"
        />
      </div>

      {children[stepNumber]}
    </>
  );
}
